import { MemberLookupPage } from "@pages/memberLookup/MemberLookupPage";
import { createFileRoute } from "@tanstack/react-router";

import { zodValidator } from "@tanstack/zod-adapter";

import { z } from "zod";

const memberSearchSchema = z.object({
  email: z.string().catch(""),
  caseNum: z.string().catch(""),
});

export type MemberSearchParams = z.infer<typeof memberSearchSchema>;

export type MemberSearch = z.infer<typeof memberSearchSchema>;

export const Route = createFileRoute("/gs-admin/members/search")({
  component: MemberLookupPage,
  validateSearch: zodValidator(memberSearchSchema),
});
